<template>
    <div :id="'SliderView_'+sliderPageName" class="general-slider">
        <!--Image Slider-->
        <div v-if="sliderData.length > 0" class="wellness-slider-main-section col-xs-12 float-l">
            <!--slider-->
            <div class="row">
                <div :id="'myCarousel'+sliderPageName" class="carousel slide" data-ride="carousel">
                    <ol class="carousel-indicators">
                        <template v-for="(masterSlider, index) in sliderData">
                            <template v-if="index == 0">
                                <li :data-target="'#myCarousel'+sliderPageName" :data-slide-to="masterSlider.counter" class="active"></li>
                            </template>
                            <template v-else>
                                <li :data-target="'#myCarousel'+sliderPageName" :data-slide-to="masterSlider.counter"></li>
                            </template>
                        </template>
                    </ol>
                    <div class="carousel-inner">
                        <template v-for="(masterSlider, index) in sliderData">
                            <template v-if="masterSlider.image != ''">
                                <template v-if="masterSlider.description != ''">
                                    <div v-if="index == 0" class="item active">
                                        <img :src="masterSlider.image" alt="Slide" style="width:100%;">
                                        <div class="carousel-caption">
                                            <p>{{masterSlider.description}}</p>
                                        </div>
                                    </div>
                                    <div v-else class="item">
                                        <img :src="masterSlider.image" alt="Slide" style="width:100%;">
                                        <div class="carousel-caption">
                                            <p>{{masterSlider.description}}</p>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div v-if="index == 0" class="item active">
                                        <img :src="masterSlider.image" alt="Slide" style="width:100%;">
                                    </div>
                                    <div v-else class="item">
                                        <img :src="masterSlider.image" alt="Slide" style="width:100%;">
                                    </div>
                                </template>
                            </template>
                        </template>
                    </div>
                </div>
                <!--<b-carousel id="carousel1"
                            style="text-shadow: 1px 1px 2px #333;"
                            controls
                            indicators
                            background="#ababab"
                            :interval="4000"
                            img-width="1200"
                            img-height="450"
                            v-model="slide"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                            >
                    <template v-for="(masterSlider, index) in sliderData">
                        <template v-if="masterSlider.image != ''">
                            <template v-if="masterSlider.description != ''">
                                <b-carousel-slide v-if="index == 0" :caption="masterSlider.description"
                                                  :img-src="masterSlider.image">
                                </b-carousel-slide>
                                <b-carousel-slide v-else :caption="masterSlider.description" :img-src="masterSlider.image">
                            </b-carousel-slide>
                        </template>
                        <template v-else>
                            <b-carousel-slide v-if="index == 0" class="item active" :img-src="masterSlider.image">
                            </b-carousel-slide>
                            <b-carousel-slide v-else class="item" :img-src="masterSlider.image">
                            </b-carousel-slide>
                        </template>
                    </template>
                </template>
            </b-carousel>-->
        </div>
    </div>
    <!--End Image Slider-->
</div>
</template>
<script>
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import { HTTP } from '../http-common';
    import bCarousel from 'bootstrap-vue/es/components/carousel/carousel';
    import bCarouselSlide from 'bootstrap-vue/es/components/carousel/carousel-slide';

    var self;
    export default {
        name: 'slider',
        props: {
            sliderType: '',
            location_type: '',
        },
        mixins: [SessioMixin],
        components: {
            'b-carousel': bCarousel,
            'b-carousel-slide': bCarouselSlide,
        },
        data() {
            return {
                error: '',
                sliderPageName: '',
                locationType: '',
                sliderData: [],
                slide: 0,
                sliding: null
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            /*self.MenuClose();*/
            self.sliderPageName = this.sliderType.type;
            self.locationType = this.sliderType.location_type;
            self.loadSlider();
            self.getBuildVersion();
        },

        methods: {
            onSlideStart(slide) {
                this.sliding = true
            },
            onSlideEnd(slide) {
                this.sliding = false
            },
            loadSlider() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: 0,
                    type: self.sliderPageName,
                    location_type: self.locationType,
                };

                HTTP.post("getslider", data, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.sliderData = response.data.content;
                                self.$nextTick(function () {
                                    $('.carousel').carousel({
                                        interval: 5000
                                    });
                                });
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            getFirstWord: function (str) {
                str = str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return str.split(' ')[0];
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/SliderComponent.vue